/**
 * Public KNDLA photo albums.
 * Leave the array empty until you upload your real photographs.
 * Images go in frontend/public/photos/ALBUM_SLUG/ and use paths beginning with /photos/.
 *
 * EXAMPLE (remove the // from each line AFTER uploading these images):
 *
 * {
 *   slug: "latin-night-2026",
 *   title: "KNDLA Latin Night",
 *   date: "2026-10-10",
 *   cover: "/photos/latin-night-2026/cover.jpg",
 *   photos: [
 *     "/photos/latin-night-2026/01.jpg",
 *     "/photos/latin-night-2026/02.jpg",
 *   ],
 * },
 *
 * The photo album title is a proper name and stays the same in every language.
 */
export const PHOTO_ALBUMS = [];
